import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosApi from "../../../utils/httpClient";

const name = "bookmarksEvent";
const initialState = {
  bookmarksEvent: [],
  loading: false,
  error: null,
};

export const bookmarksEventAPI = createAsyncThunk(
  "bookmarks/event",
  async ({ search, skip, limit, id, type }) => {
    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }bookmark/events?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`
    );
    return data.data;
  }
);

const bookmarksEventSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(bookmarksEventAPI.pending, (state) => {
      state.bookmarksEvent = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(bookmarksEventAPI.fulfilled, (state, action) => {
      state.bookmarksEvent = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(bookmarksEventAPI.rejected, (state, action) => {
      state.bookmarksEvent = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default bookmarksEventSlice.reducer;
